<script setup lang="ts">
import { debounce } from '@/helpers/tools'
import KpTextfield from '@/components/kp-textfield.vue'
import { ref, watch } from 'vue'

const emit = defineEmits<{
    (e: 'executeSearch', v: string): void
}>()

const searchString = ref('')
watch(searchString, () => {
    executeSearch()
})
const executeSearch = debounce(function () {
    emit('executeSearch', searchString.value)
})
function onSearchKey(event: KeyboardEvent) {
    if (event.key === 'Enter') {
        executeSearch()
    }
}
function clearSearch() {
    searchString.value = ''
    executeSearch()
}
</script>

<template>
    <kp-textfield
        label=""
        v-model="searchString"
        placeholder="Suchen..."
        single-line
        hide-details
        clearable
        append-inner-icon="fas fa-search"
        clear-icon="fas fa-times"
        class="small-icon"
        @click:append="executeSearch"
        @keydown="onSearchKey"
        @click:clear="clearSearch"
    >
        <template v-slot:prepend-inner>
            <v-icon size="17px" class="mt-1 mr-2">fas fa-search</v-icon>
        </template>
    </kp-textfield>
</template>
